import React, { useEffect, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import useWindowResize from "@/hooks/useWindowResize"
import FilterComponent from "@/components/Shared/VisualNav/FilterComponent"
import { dataLayerForForArrows } from "@/components/Shared/VisualNav/analytics/index"
import {
  selectProductListState,
  setFilterQueryState,
  setIsFromVisualNav,
  setServerData,
} from "@/store/features/productListSlice"
import { PDP_SLIDER_SIZES } from "@/constants/index"
import {
  LEFT_ARROW,
  RIGHT_ARROW,
} from "@/components/Shared/VisualNav/analytics/constant"
import styles from "@/components/Shared/VisualNav/index.module.scss"
import { DOUBLE_QUOTE_REGEX } from "@/constants/regex"

const VisualNavigation = (data = {}) => {
  const dispatch = useDispatch()
  const productlistState = useSelector(selectProductListState)
  const {
    visualNavAppliedFilters = [],
    facet_labels: facetLabels = {},
    currentAppliedfiltersVisualNav = [],
    isServerData = false,
  } = productlistState
  const [width] = useWindowResize()
  const myAuthoredData = data?.data[":items"]
  const listOfFilters = myAuthoredData
  const [currentIndex, setCurrentIndex] = useState(0)
  const [productsPerView, setProductsPerView] = useState(1)
  const [selectedNav, setSelectedNav] = useState([])
  const sliderRef = useRef(null)
  const productArray = Object.values(listOfFilters)
  const { visualNavPlp } = PDP_SLIDER_SIZES
  const [isMobile, setIsMobile] = useState(width <= PDP_SLIDER_SIZES)
  const suppressSelectionCheck = useRef(false)

  useEffect(() => {
    setIsMobile(width <= visualNavPlp)
    const calculateProductsPerView = () => {
      if (sliderRef.current) {
        const containerWidth = sliderRef.current.offsetWidth
        const productWidth = 335
        if (productWidth) {
          setProductsPerView(Math.floor(containerWidth / productWidth))
        }
      }
    }
    calculateProductsPerView() // Initial calculation
    window.addEventListener("resize", calculateProductsPerView) // Recalculate on resize
    return () => {
      window.removeEventListener("resize", calculateProductsPerView)
    }
  }, [])

  const handleNext = () => {
    setCurrentIndex(prevIndex =>
      prevIndex + 1 >= productArray.length ? 0 : prevIndex + 1
    )
    dataLayerForForArrows("right")
  }

  const handlePrevious = () => {
    setCurrentIndex(prevIndex =>
      prevIndex === 0 ? Math.max(0, productArray.length - 1) : prevIndex - 1
    )
    dataLayerForForArrows("left")
  }

  const clearVisualNavFilterSelection = () => {
    suppressSelectionCheck.current = true // prevent re-selection flicker
    setSelectedNav([])
    sessionStorage.removeItem("filterName")
    dispatch(setFilterQueryState("NONE"))
    dispatch(setIsFromVisualNav(false))
  }

  const formatVisualNavFilterName = query => {
    return facetLabels[query]?.replace(" ", "_") ?? query
  }

  const getIsVisualNavAppliedOrSelected = (productArray = []) => {
    if (suppressSelectionCheck.current) {
      suppressSelectionCheck.current = false // reset after skipping
      return
    }

    const matchedIndex = productArray?.findIndex(
      ({ filterName, filterValue }) => {
        return currentAppliedfiltersVisualNav?.some(filterStr => {
          const [facet, value] = filterStr.split(" - ")
          return facet === filterName && value === filterValue
        })
      }
    )

    if (matchedIndex !== -1) {
      // Only update if value actually changes
      setSelectedNav(prev =>
        prev.length === 1 && prev[0] === matchedIndex ? prev : [matchedIndex]
      )
    } else {
      setSelectedNav(prev => (prev.length === 0 ? prev : []))
    }
  }

  const handleNavSelection = (index, filterName, filterValue) => {
    const filteredValue = filterValue?.replace(DOUBLE_QUOTE_REGEX, '\\"')
    if (selectedNav.includes(index)) {
      clearVisualNavFilterSelection()
    } else {
      dispatch(
        setFilterQueryState(
          `${formatVisualNavFilterName(filterName)}:${filteredValue}`
        )
      )
      dispatch(setIsFromVisualNav(true))
      dispatch(setServerData(false))
    }
  }

  useEffect(() => {
    if (!visualNavAppliedFilters.length) {
      setSelectedNav([])
    }
  }, [visualNavAppliedFilters])

  useEffect(() => {
    getIsVisualNavAppliedOrSelected(productArray)
  }, [currentAppliedfiltersVisualNav, isServerData])

  return (
    <div className={`${styles.ProductWrapper} visualNavWrapper`}>
      <div className="filter-conatiner" ref={sliderRef}>
        {!isMobile ? (
          <>
            {productsPerView < productArray.length ? (
              <div className="Buttons">
                <div
                  className={`slider-btn-prev${
                    currentIndex === 0 ? "-disable" : ""
                  }`}
                  onClick={currentIndex === 0 ? null : handlePrevious}
                >
                  <img alt="leftarrow" src={LEFT_ARROW}></img>
                </div>
                <div
                  className={`slider-btn-next${
                    currentIndex + productsPerView === productArray.length
                      ? "-disable"
                      : ""
                  }`}
                  onClick={
                    productArray.length - currentIndex === productsPerView
                      ? null
                      : handleNext
                  }
                >
                  <img alt="rightarrow" src={RIGHT_ARROW}></img>
                </div>
              </div>
            ) : null}
            <div
              className="plp-block"
              style={{
                transform: `translateX(-${
                  (currentIndex / productsPerView) * 100
                }%)`,
              }}
            >
              {productArray.map((product, index) => {
                return (
                  <React.Fragment key={index}>
                    <div
                      key={index}
                      className="display-item"
                      style={{
                        flex: `0 0 calc(100% / ${productsPerView})`,
                      }}
                    >
                      <FilterComponent
                        data={product}
                        index={index}
                        productLength={productArray.length}
                        onNavSelection={handleNavSelection}
                        isSlected={selectedNav.includes(index)}
                      />
                    </div>
                  </React.Fragment>
                )
              })}
            </div>
          </>
        ) : (
          <div className="plp-block">
            {productArray.map((product, index) => (
              <div key={index} className="display-item">
                <FilterComponent
                  data={product}
                  index={index}
                  productLenghth={productArray?.length}
                  onNavSelection={handleNavSelection}
                  isSlected={selectedNav.includes(index)}
                />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}
export default VisualNavigation
